/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useMemo } from 'react';
import { getLandingPageUrl } from '@jira/servicedesk__insight-common-utils-insight-urls/src/getLandingPageUrl.tsx';
import { hasAssetsEntitlement } from '@jira/servicedesk__insight-common-services-workspace-context/src/fetchWorkspaceId.tsx';
import JSMAssetsSchemasIcon from '@jira/illustrations__icons/src/ui/jsm-assets-schemas/index.tsx';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { ASSETS_SCHEMAS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/item-id.tsx';
import { MENU_ID_ASSETS_SCHEMAS } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import type { NavSubmenuHeader } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { useFormattedMessageAndIcon } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/utils/use-formatted-message-and-icon/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useAssetsTenantContext } from '@jira/assets-app__assets-tenant-context-provider/src/useAssetsTenantContext.tsx';
import { useAssetsUIAnalytics } from '../../../common/use-assets-ui-analytics/index.tsx';

const jsmAssetsSchemas = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.schemas.jsm-assets-schemas',
	defaultMessage: 'Schemas',
	description: 'Assets dropdown item to link customer to Schemas page.',
});

export const HeaderSchemasMenuItems: NavSubmenuHeader = () => {
	const { formatMessage } = useIntl();
	const assetsTenantContext = useAssetsTenantContext();
	const hasAssetsEntitlementEnabled =
		fg('assets_for_you') && hasAssetsEntitlement(assetsTenantContext);
	const schemasLink = useMemo(
		() => (hasAssetsEntitlementEnabled ? `${getLandingPageUrl()}/schemas` : getLandingPageUrl()),
		[hasAssetsEntitlementEnabled],
	);
	const { icon: formattedSchemasIcon } = useFormattedMessageAndIcon(
		jsmAssetsSchemas,
		JSMAssetsSchemasIcon,
	);
	const { fireUINavigationItemAnalytics } = useAssetsUIAnalytics();

	return (
		<Nav4MenuLinkItem
			menuId={MENU_ID_ASSETS_SCHEMAS}
			elemBefore={formattedSchemasIcon}
			href={schemasLink}
			onClick={() => fireUINavigationItemAnalytics(ASSETS_SCHEMAS)}
		>
			{formatMessage(jsmAssetsSchemas)}
		</Nav4MenuLinkItem>
	);
};
